// extracted by mini-css-extract-plugin
export default {"root":"Hinted_root__rnda2"};